$( document ).ready(function() {
$( ".sc" ).text( "Select option" );
$( ".sc" ).css( "color", "#d3d3d3" );
});


$('span.sc').attr('id', function(i) {
        return 'scLabel'+(i+1);
                });

$( "input[name=option-0]:radio" )
  .change(function () {
    var str = "";
      $( "input[name=option-0]:radio:checked + label" ).each(function() {
      str += $( this ).text() + " ";        
    });  	
    $( "#scLabel1" ).text( str );
  	$( "#scLabel1" ).css( "color", "#000" );
  })
  .change();


$( "input[name=option-1]:radio" )
  .change(function () {
    var str1 = "";
      $( "input[name=option-1]:radio:checked + label" ).each(function() {
      str1 += $( this ).text() + " ";
    });
    $( "#scLabel2" ).text( str1 );
  	$( "#scLabel2" ).css( "color", "#000" );

  })
  .change();

$( "input[name=option-2]:radio" )
  .change(function () {
    var str2 = "";
      $( "input[name=option-2]:radio:checked + label" ).each(function() {
      str2 += $( this ).text() + " ";
    });
    $( "#scLabel3" ).text( str2 );
  	$( "#scLabel3" ).css( "color", "#000" );
  })
  .change();

$( "input[name=option-3]:radio" )
  .change(function () {
    var str3 = "";
      $( "input[name=option-3]:radio:checked + label" ).each(function() {
      str3 += $( this ).text() + " ";
    });
    $( "#scLabel4" ).text( str3 );
  	$( "#scLabel3" ).css( "color", "#000" );
  })
  .change();


$( "input:radio" )
.change(function () {
$('#accordion').accordion('option', 'active', false);
  });